import React, { FC } from "react";
import { Display } from "stentor-models";
import { isCarousel, isList } from "../../utils/guards";
import { SearchResponseCarouselDisplay } from "../SearchResponseCarouselDisplay";
import { SearchResponseListDisplay } from "../SearchResponseListDisplay";

export interface SearchResponseDisplayProps {
    readonly display: Display;
}

export const SearchResponseDisplay: FC<SearchResponseDisplayProps> = props => {
    const { display } = props;
    return (
        <div className="xapp-search-response-display">
            {isList(display) && <SearchResponseListDisplay list={display} />}
            {isCarousel(display) && <SearchResponseCarouselDisplay carousel={display} />}
        </div>
    );
};